import { StatusTag } from 'components/ui';
import PropTypes from 'prop-types';
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useStoreSubscriptionPlan } from 'utils/useStoreSubscriptionPlan';

/**
 * SideBar Navigation Links with Active Link highlight
 * @param {{
 * children: string | React.ReactNode,
 * to:{pathname:string,search:string},
 * icon:import('react').ReactNode,
 * fullSize:boolean,
 * subscriptionAccess?:number,
 * iconsColor?:"white"|"black"
 * }} param0
 * @returns
 */
export default function NavigationLink({
  children,
  to,
  icon: Icon,
  fullSize,
  subscriptionAccess = 0,
  iconsColor = 'white',
}) {
  const location = useLocation();
  const activeLink = location.pathname.includes(to.pathname);
  const justifyIcon = fullSize ? 'justify-start' : 'justify-center';

  const { storeSubscriptionPlan } = useStoreSubscriptionPlan();

  return (
    <Link
      to={to}
      className={` flex text-base justify-between items-center font-bold hover:bg-white hover:bg-opacity-10 px-4 py-3 2xl:py-4 rounded-lg  ${
        subscriptionAccess > storeSubscriptionPlan &&
        'cursor-not-allowed opacity-50'
      }`}
      onClick={(e) => {
        if (subscriptionAccess > storeSubscriptionPlan) {
          e.preventDefault();
        }
      }}
    >
      <div className={`flex space-x-4 items-center ${justifyIcon}`}>
        {/* @ts-ignore */}
        <Icon
          className={`w-6 h-6 ${
            iconsColor === 'white' ? 'text-white' : 'text-black'
          }`}
        />
        {fullSize && <span className="truncate">{children}</span>}
      </div>
      {subscriptionAccess > storeSubscriptionPlan && (
        <div className="pr-1.5 font-normal justify-self-end">
          <StatusTag variant="main">Paid</StatusTag>
        </div>
      )}
      {activeLink && (
        <div className="absolute right-0 w-1 h-10 2xl:h-12 bg-segments-accent-color-orange rounded-l-md" />
      )}
    </Link>
  );
}
NavigationLink.propTypes = {
  children: PropTypes.any.isRequired,
  to: PropTypes.object.isRequired,
  icon: PropTypes.any.isRequired,
  fullSize: PropTypes.bool.isRequired,
};
